import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './components/SEO';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <SEO page="notFound" />
      <section className="ds-page-hero not-found-hero">
        <div className="container">
          <p className="ds-eyebrow">ERROR <span className="ds-num">404</span></p>
          <h1 className="ds-h1">ページが見つかりません</h1>
          <p className="ds-lead">
            お探しのページは移動または削除された可能性があります。
          </p>
          <div className="not-found-actions">
            <Link to="/" className="ds-btn ds-btn--primary ds-btn--arrow">
              ホームに戻る
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NotFoundPage;
